export default "__VITE_ASSET__CzyIEDHJ__"